import http from '@/utils/http';
import i18n from '@/main';

export default {
    consultar(tipo, documento, salvar = true, arquivo, idRequest = 'semId') {
        return http.post({
            url: `/diagnostico/buscar-dados/socioambiental/${tipo}/${documento}/${idRequest}?salvar=${salvar}`,
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.realizandoDiagnosticoSocioambiental'
            ),
            data: { arquivo: arquivo }
        });
    },

    consultarEmLote(
        tipo,
        documento,
        salvar = true,
        lockscreen = true,
        arquivo,
        idRequest = 'semId'
    ) {
        return http.post({
            url: `/diagnostico/buscar-dados/socioambiental/${tipo}/${documento}/${idRequest}?salvar=${salvar}`,
            lockScreen: lockscreen,
            lockMessage: i18n.t(
                'mensagens.sistema.realizandoDiagnosticoSocioambiental'
            ),
            data: { arquivo: arquivo }
        });
    },

    consultarMultiplos(tipo, documento, arquivo, idRequest) {
        return http.post({
            url: `/diagnostico/buscar-dados/socioambiental/${tipo}/${documento}/${idRequest}?salvar=true`,
            lockScreen: false,
            data: { arquivo: arquivo }
        });
    },

    buscarPorId(idDiagnostico) {
        return http.get({
            url: `diagnostico-socioambiental/${idDiagnostico}`,
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.buscandoDiagnosticoSocioambientalSalvo'
            )
        });
    },

    realizarDiagnosticoSocioambientalProtocolo(payload) {
        return http.post({
            url: '/diagnostico-socioambiental/listagem-protocolo',
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.realizandoDiagnosticoSocioambiental'
            ),
            data: payload
        });
    },

    analisarBuffer(geometria, idDiagnosticoSocioambiental) {
        return http.post({
            url: `/diagnostico/${idDiagnosticoSocioambiental}/analisar-buffer`,
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.realizandoDiagnosticoSocioambientalDasAreasProximas'
            ),
            data: { geometrias: geometria }
        });
    },

    exportarPdf(params) {
        return http.post({
            url: '/diagnostico/exportar/pdf',
            data: { dados: params },
            lockScreen: false
        });
    },

    async verifyUrl(url) {
        try {
            const response = await http.get({
                url: url,
                lockScreen: true,
                lockMessage: i18n.t(
                    'mensagens.sistema.verificandoDisponibilidadeDoServico'
                )
            });
            if (response.status >= 200 && response.status <= 299) {
                return true;
            }
            return false;
        } catch (err) {
            return false;
        }
    },

    consultaControleDiagnostico(body, { page, size, sort }) {
        return http.post({
            url: `/diagnostico/filtrar-relatorio?page=${
                page - 1
            }&size=${size}&sort=${sort}`,
            data: body,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoDadosDeDiagnosticos')
        });
    },

    graficoControleDiagnostico(body) {
        return http.post({
            url: `/diagnostico/grafico`,
            data: body,
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.buscandoGraficosDeDiagnosticos'
            )
        });
    },

    realizarDiagnosticoCadastroTerritorio(idTerritorio) {
        return http.get({
            url: `diagnostico-socioambiental/cadastro-territorio/${idTerritorio}`,
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.realizandoDiagnosticoSocioambiental'
            )
        });
    },

    exportarControleRequisicaoDiagnostico(body) {
        const fileLink = document.createElement('a');
        try {
            return http
                .post({
                    url: `/diagnostico/requisicao-xlsx`,
                    data: body,
                    responseType: 'blob',
                    lockScreen: true,
                    lockMessage: i18n.t(
                        'mensagens.sistema.preparandoDadosParaDownload'
                    )
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;
                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    buscarDiagnosticoCarDoTerritorio(territorio) {
        return new Promise((resolve, reject) => {
            if (
                territorio &&
                territorio.dadosTerritorio &&
                territorio.dadosTerritorio.cars &&
                territorio.dadosTerritorio.cars.length
            ) {
                const promises = [];
                territorio.dadosTerritorio.cars.forEach(car => {
                    if (car.codigo) {
                        const request = http.get({
                            url: `/diagnostico/${territorio.idDiagnosticoSocioambiental}/car/${car.codigo}`
                        });
                        promises.push(request);
                    }
                });
                Promise.all(promises)
                    .then(responses => {
                        const responseCars = [];
                        responses.forEach(({ data, status }) => {
                            if (status === 200 && data && data.imovel) {
                                responseCars.push(data);
                            }
                        });
                        resolve(responseCars);
                    })
                    .catch(error => {
                        reject(error);
                    });
            } else {
                resolve([]);
            }
        });
    },
    consultarSocioambientalPY(geometria, idRequest) {
        return http.post({
            url: `diagnostico/buscar-dados/socioambiental/GEOMETRIA/geometria/${idRequest}?salvar=true`,
            lockScreen: false,
            data: { arquivo: geometria }
        });
    }
};
